// @flow

import React from "react";

import { connect } from "react-redux";

import classnames from "classnames";

import {
  registrationFieldUpdate,
  registrationFieldValidate
} from "redux/ducks/Registration";

import TermsConditionsModal from "components/TermsConditionsModal";

type AccountProps = {
  history: Object,
  updateField: Function,
  user: Object,
  validateField: Function,
  validation: Object
};

const Account = ({
  history,
  updateField,
  user,
  validateField,
  validation
}: AccountProps) => {
  const onFieldChange = field => {
    return (ev: SyntheticInputEvent<HTMLInputElement>) => {
      updateField(field, ev.currentTarget.value);
    };
  };

  const onFieldValidate = field => {
    validateField(field);
  };

  const onTermsChanged = e => {
    updateField("terms", e.target.checked);
    validateField("terms");
  };

  const onSubmit = e => {
    e.preventDefault();
    history.push("/sign-up/profile");
  };

  return (
    <div className="account">
      <h2>Sign Up</h2>
      <p>Sign up to start posting your events</p>
      <form id="accountForm" noValidate>
        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input
            type="email"
            className={classnames("form-control", {
              "is-invalid": validation.errors.email
            })}
            name="email"
            onChange={onFieldChange("email")}
            onBlur={onFieldValidate.bind(this, "email")}
          />
          <div className="invalid-feedback">{validation.errors.email}</div>
        </div>
        <div className="form-group">
          <label htmlFor="password">Password</label>
          <input
            type="password"
            className={classnames("form-control", {
              "is-invalid": validation.errors.password
            })}
            placeholder="(must be at least 8 characters)"
            name="password"
            onChange={onFieldChange("password")}
            onBlur={onFieldValidate.bind(this, "password")}
          />
          <div className="invalid-feedback">{validation.errors.password}</div>
        </div>
        <div className="form-group">
          <label htmlFor="passwordConfirmation">Confirm Password</label>
          <input
            type="password"
            className={classnames("form-control", {
              "is-invalid": validation.errors.passwordConfirmation
            })}
            name="passwordConfirmation"
            onChange={onFieldChange("passwordConfirmation")}
            onBlur={onFieldValidate.bind(this, "passwordConfirmation")}
          />
          <div className="invalid-feedback">
            {validation.errors.passwordConfirmation}
          </div>
        </div>
        <div className="form-group">
          <label htmlFor="referralCode">Referral Code</label>
          <input
            type="referralCode"
            className={classnames("form-control")}
            placeholder="Referral Code"
            name="referralCode"
            onChange={onFieldChange("referralCode")}
            onBlur={onFieldValidate.bind(this, "referralCode")}
          />
        </div>
        <label className="checkbox">
          I have read and agree to the <a target="_blank" rel="noopener noreferrer" href="https://go4.io/privacy-policy/">Privacy Policy</a> and <a target="_blank" rel="noopener noreferrer" href="https://go4.io/terms-and-conditions/">Terms and Conditions</a>.
          <input type="checkbox" name="terms" checked={user.terms} onChange={onTermsChanged} />
          <span></span>
        </label>
        <button
          type="submit"
          className="btn btn-danger bold-button"
          disabled={!validation.validAccount}
          onClick={onSubmit}
        >
          Save and Continue
        </button>
      </form>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    user: state.registration.user,
    validation: state.registration.validation
  };
}

function mapDispatchToProps(dispatch) {
  return {
    updateField: (field, value) =>
      dispatch(registrationFieldUpdate(field, value)),
    validateField: field => dispatch(registrationFieldValidate(field))
  };
}

export { Account };

export default connect(mapStateToProps, mapDispatchToProps)(Account);
